interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  const baseBtn =
    'flex h-9 w-9 items-center justify-center rounded-md font-label text-sm transition-colors';

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(current - 1)}
        disabled={current === 1}
        className={`${baseBtn} gap-1 px-3 w-auto border border-background-300 text-foreground-700 hover:bg-secondary-100 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer`}
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true" />
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          aria-current={page === current ? 'page' : undefined}
          className={`${baseBtn} cursor-pointer ${
            page === current
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-300 text-foreground-700 hover:bg-secondary-100'
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(current + 1)}
        disabled={current === totalPages}
        className={`${baseBtn} gap-1 px-3 w-auto border border-background-300 text-foreground-700 hover:bg-secondary-100 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer`}
      >
        下一页
        <i className="ri-arrow-right-s-line" aria-hidden="true" />
      </button>
    </nav>
  );
}